export default __webpack_public_path__ + "static/media/group-608@3x.574eefec.png";